// extracted by mini-css-extract-plugin
module.exports = {"row":"Privacy-module--row--12xB3","rowContent":"Privacy-module--row-content--1UD5y"};